import api from "./api.js";

export default class AskApi {
  static async Create(data) {
    return await api.post(`web/inquiry`, data);
  }  
}
